import { graphql, useStaticQuery } from 'gatsby';

import { trimPath } from 'src/helpers/path-matching-helper';

export const useGatsbyPaths = () => {
  const data = useStaticQuery<Queries.pagesQueryQuery>(graphql`
    query pagesQuery {
      allSitePage(filter: { path: { regex: "/^(?!/admin).*/" } }) {
        nodes {
          path
        }
      }
    }
  `);

  const paths = new Set<string>(
    data?.allSitePage?.nodes === null || data?.allSitePage?.nodes === undefined
      ? []
      : data.allSitePage.nodes.map((node) => node.path)
  );

  const isGatsbyPath = (path: string): boolean => {
    const normalisedPath = trimPath(path) === '' ? '/' : `/${trimPath(path)}/`;

    return paths.has(normalisedPath);
  };

  return { paths, isGatsbyPath };
};
